/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import BaseModel from './base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { decorate, isObservableArray, observable } from 'mobx';
import LayoutModel from '../layout-model';
import StyleHandler from '../../adapter/style-handler';
import ShapeModel from '../shape-model';
import ImageQuickLookManager from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import ImageUrl from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-url';
import i18n from '@i18next/i18n';
import { assert } from 'ts-essentials';

// lodash部分引入
import _unset from 'lodash/unset';
import _has from 'lodash/has';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';
import ConvertEngine from '../convert/convertEngine';
import { addPosition as sdkToUIAddPosition } from '../../adapter/style-adapters/sdk-ui';
import { transaction } from '@src/slide/domain/slide-app';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import {
    IPresentationBaseModel,
    PresentationModelSdkTypeV3,
} from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import {
    IPresentationModelProps,
    DefaultSize,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/presentation-model-props.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { copy } from '@src/slide/infrastructure/module/independent/object-operation';
import { enumerateGroupItems } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import UpdateAndRemoveLogic from '@src/slide/domain/ui-model/element-modeles/property/fill/update-remove';
import SectionProperty, { ISectionProperty } from '../property/section';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import ClearanceUtils from '@src/slide/domain/ui-model/utils/clearance-utils';
import MasterLayoutUtils from '@src/slide/domain/ui-model/utils/master-layout-utils';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { ISectionManager } from '@src/slide/application/service/section-manager/section-manager.interface';
import { createPageModel } from '../factories/page-models-factory';
import MasterModel from '../master-model';
import GuideModel from '../guide-model';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import {
    DataType,
    ILayoutDataModel,
    ISlideData,
    type PresentationDataModel,
    STSlideSizeType,
    IObservableDataModel,
    DataModelChange,
    MasterDataModel,
    STPlaceholderType,
    IShapeData,
    ILayoutData,
    MutationSource,
    IMasterDataModel, ISlideDataModel,
    IPresentationDataModel,
} from '@tencent/slide-sdk-model';
import { SlidePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/page/slide-property-converter';
import { IThemeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import ThemeModel from '@src/slide/domain/ui-model/element-modeles/theme-model';
import { generate } from 'shortid';
import { IGroupModel } from '../Interface/group-model.interface';
import { IGuideModel as IGuideModelV3 } from '@src/slide/domain/ui-model/element-modeles/Interface/guide-model-v3.interface';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import TaskGroup from '@src/slide/infrastructure/module/dependent/taskManager/taskGroup';
import ModelConverterBridge from '@src/slide/domain/ui-model/element-modeles/convert/model-converter-bridge';
import {
    PresentationPropertyType,
} from '@src/slide/domain/ui-model/element-modeles/factories/presentation-property-type';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

class PresentationBaseModel extends BaseModel implements IPresentationBaseModel {
    @observable
    public layoutList: Array<ILayoutModel> = [];
    @observable
    public masterList: Array<IMasterModel> = [];
    @observable
    public themeList: Array<IThemeModel> = [];
    @observable
    public firstSlideNum = 1;
    @observable
    public sectionList: ISectionModel[] | undefined = undefined;
    @observable
    public guideModel: GuideModel | IGuideModelV3;
    public layoutChildrenMap = {
        // key为layoutId
    };

    public masterChildrenMap = {
        // key为masterId
    };

    public slideCount = 0;

    public loadTime = -1;
    public mobileVisibleTime = -1; // mobile显示页渲染耗时
    public converted = false;

    public operation = {
        loading: false,
        __syncSDKData: false, // 转换过程中 SKD 数据有变化 需要转换完成后再次 转转一次SDK 数据保持最新UI 数据.

        __firstLoad: false, // 是否是 导入状态（包含显示） 状态. (warning: log 使用)
        stop: false,
    };
    public props: IPresentationModelProps;
    public sdkData: IPresentationDataModel | null = null;
    public readonly isPresentation = true;
    public declare children: ISlideModel[];
    protected sectionManager?: ISectionManager;
    protected masterAndLayoutTaskGroup: TaskGroup;

    private sectionPropertyInstance: ISectionProperty | undefined = undefined;

    public constructor(props?: {}) {
        super(props);
        this.type = UIModelType.PRESENTATION;
        decorate(this.operation, {
            // 放到上面的对象里面eslint会报错，所以用这种方式将loading字段变为observable的
            loading: observable,
        });
        this.props = {
            style: {},
            slideWidth: DefaultSize.width,
            slideHeight: DefaultSize.height,
            slideSizeType: SlideSizeType.SLIDE_SIZE_16_9,
        };
        Object.defineProperty(this, 'styleHandler', {
            enumerable: false, // 不可遍历
            value: new StyleHandler(this),
        });
    }

    public get globalFont() {
        // 3.0上层除了此处没有地方用defaultTextStyle，所以暂时先不在convert转了，直接在此处赋值
        const font = (this.sdkData as unknown as PresentationDataModel)?.props?.defaultTextStyle?.lvl1pPr?.defRPr;
        return font?.ea?.typeface || font?.latin?.typeface || '';
    }

    public get itemValues(): any {
        return { font: this.globalFont };
    }

    public async bindSDK(sdkData): Promise<void> {
        this.layoutChildrenMap = {};
        this.masterChildrenMap = {};
        await super.bindSDK(sdkData);
    }

    /**
     * 根据当前选中的页面来添加新的页面
     */
    public addDefaultSlide(): void {
        window.log.info('presentation addDefaultSlide');

        const ifRet = this._addDefaultSlideCaseNone();
        if (ifRet) {
            return;
        }
        const inheritInfo = this.findToAddInheritInfo();
        inheritInfo && this.addSlideFromInheritInfo(inheritInfo.masterIndex, inheritInfo.layoutIndex);
    }

    /**
     * 通过添加继承自layout的slide节点
     */
    // eslint-disable-next-line complexity
    public addSlide(slides?: Array<ILayoutModel>): void {
        // 如果在编辑态下，shape-element的blur通过select prop的改变触发，会比click事件晚，造成changeset时序错误，因此手动触发blur上传
        (() => {
            if (this.selectionService) {
                const selectedElements = this.selectionService.selectedElements?.selectedArray;

                if (selectedElements && selectedElements.length === 1) {
                    if ((selectedElements[0] as IElementBaseModel).type !== UIModelType.SHAPE) return;
                    const selectedElement = selectedElements[0] as ShapeModel;

                    selectedElement.editorInstance?.triggerBlur();
                }
            }
        })();

        window.log.info('presentation addSlide');

        this.addSlideV3(slides);
    }

    /**
     * 添加一个默认版式
     * 插入版式文档：https://doc.weixin.qq.com/doc/w3_Ae4ADwbBAJspJaUHhEDQuW3ew4hCs?scode=AJEAIQdfAAosxts9CmAe4ADwbBAJs
     */
    public addLayout(): void {
        if (!this.selectionService) {
            return;
        }

        const { currentSlideType, currentSlide } = this.selectionService;
        const sdkMasterList = (this.sdkData as PresentationModelSdkTypeV3)?.masterList || [];
        // 获取插入的位置（sdk 数据中的位置）
        const master = currentSlide?.getRelationMasterModel();
        const insertIndex =
            {
                [UIModelType.MASTER]: MasterLayoutUtils.getIndexFromMaster(
                    this.masterList,
                    this.layoutList,
                    currentSlide as IMasterModel,
                ),
                [UIModelType.LAYOUT]: MasterLayoutUtils.getIndexFromLayout(
                    master?.layoutList ?? [],
                    currentSlide as ILayoutModel,
                ),
            }[currentSlideType] ?? 0;
        // 获取插入版式的母版
        const masterIndex =
            {
                [UIModelType.MASTER]: this.masterList.findIndex(i => i.id === currentSlide?.id),
                [UIModelType.LAYOUT]: this.masterList.findIndex(i => i.id === (currentSlide as ILayoutModel)?.masterId),
            }[currentSlideType] ?? 0;
        const masterData = sdkMasterList[masterIndex] as MasterDataModel;
        transaction(() => {
            (this.sdkData as PresentationModelSdkTypeV3)?.api?.addLayouts(
                [this.createLayoutFromMaster(masterData)] as ILayoutData[],
                insertIndex,
            );
        });
    }

    /**
     * 将slide节点从fromIndex移动到toIndex
     * @param {*} toIndex slide移动到的位置moveSlide
     * @param slides
     */
    public moveSlide(toIndex, slides = this.selectionService?.selectedSlides.selectedArray || []): void {
        window.log.info('presentation moveSlide');
        if (!this.sdkData) return;

        const curSlide = this.selectionService?.currentSlide;
        const arrLength = this.selectionService?.slides.length !== undefined ? this.selectionService?.slides.length : 0;
        // 移动到了当前数组长度之外并不合理
        if (toIndex < 0 || toIndex > arrLength) return;
        const sortedSlides
            = slides.sort((a: ISlideModel, b: ISlideModel) => this.indexOfSlide(a) - this.indexOfSlide(b));

        const sdkSlides = sortedSlides.map(curItem => curItem.sdkData);
        const sdkData = this.sdkData as PresentationModelSdkTypeV3;
        if (sdkData?.sectionList?.length && !browser.isMobile) {
            // 移动端暂时不支持节
            sdkData?.api.moveSlidesWithSection(sdkSlides, toIndex);
        } else {
            sdkData?.api.moveSlides(sdkSlides, toIndex);
        }

        if (this.selectionService) {
            this.selectionService.currentSlideIndex = this.indexOfSlide(curSlide);
        }
    }

    /**
     * 将 Layout 节点移动到 toIndex
     * 移动版式文档：https://doc.weixin.qq.com/doc/w3_Ae4ADwbBAJspJaUHhEDQuW3ew4hCs?scode=AJEAIQdfAAosxts9CmAe4ADwbBAJs
     * @param {*} toIndex layout 移动到的位置（ui界面中）
     * @param slides
     */
    // eslint-disable-next-line complexity
    public moveLayout(toIndex: number, slides = this.selectionService?.selectedSlides.selectedArray || []): void {
        // 母版暂不可以移动
        if (slides.some(i => i.isMaster)) {
            return;
        }
        window.log.info('presentation moveSlide');
        if (!this.sdkData) return;

        const curSlide = this.selectionService?.currentSlide;
        const uiMasterLayoutList = MasterLayoutUtils.getUiMasterLayoutList(this.masterList);
        const gapSlide = uiMasterLayoutList[toIndex - 1];
        // 跨母版移动后要修改版式对应的母版
        const masterId =
            {
                [UIModelType.LAYOUT]: () => (gapSlide as ILayoutModel).masterId,
                [UIModelType.MASTER]: () => gapSlide.id,
            }[gapSlide?.type]?.() ?? this.masterList[0].id;
        if (!masterId) {
            return;
        }
        const sdkSlides = slides.map(curItem => curItem.sdkData);
        let sdkToIndex = 0;
        if (gapSlide?.type === UIModelType.LAYOUT) {
            sdkToIndex =
                (gapSlide.parent as IMasterModel)?.layoutList?.findIndex(e => e.id === gapSlide.id) ?? -1;
            sdkToIndex = sdkToIndex + 1;
        }
        const { sdkData: destMaster } = this.masterList.find(e => e.id === masterId) || {};
        if (destMaster) {
            (this.sdkData as PresentationModelSdkTypeV3)?.api.moveLayouts(sdkSlides, sdkToIndex, destMaster as any);
        }
        if (this.selectionService) {
            this.selectionService.currentSlideIndex = this.indexOfSlide(curSlide);
        }
    }

    public moveSlideToSection(
        gapIndex: number,
        slideIndex: number,
        sectionIndex: number,
        slides = this.selectionService?.selectedSlides.selectedArray || [],
    ): void {
        window.log.info('presentation moveSlideToSection');

        transaction(() => {
            if (!this.sdkData) return;

            const sdkSlides = slides.map(curItem => curItem.sdkData);
            const sdkData = this.sdkData as PresentationModelSdkTypeV3;
            if (sdkData?.sectionList?.length) {
                sdkData?.api.moveSlidesWithSection(sdkSlides, gapIndex);
            } else {
                sdkData?.api.moveSlides(sdkSlides, gapIndex);
            }
        });
        if (this.selectionService) {
            if (this.selectionService.currentSlideIndex < slideIndex) {
                // 向下拖动修正选中的第一页状态
                this.selectionService.currentSlideIndex = slideIndex - 1;
            } else {
                this.selectionService.currentSlideIndex = slideIndex;
            }
        }
    }

    /**
     * 删除 slide 或 layout 页面
     * @param slides
     */
    // eslint-disable-next-line complexity
    public deleteSlide(slides = this.selectionService?.selectedSlides.selectedArray || []): void {
        // 母版暂不支持删除
        if (slides.some(i => i.isMaster)) {
            this.deleteMasters(slides);
            return;
        }
        // 版式已使用，不能删除
        const slideIds = slides.map(i => i.id);
        if (this.children.some(i => slideIds.includes(i.layoutId))) {
            return;
        }

        window.log.info(`presentation deleteSlide count = ${slides.length}`);
        if (!this.sdkData) return;
        const isLayoutSlides = slides.length && slides.every(i => i.isLayout);
        const slideListLength = isLayoutSlides ? this.layoutList.length : this.children.length;

        let firstIndex = -1;
        if (slideListLength >= slides.length) {
            const sortArray = slides.sort((a, b) => this.indexOfSlide(a) - this.indexOfSlide(b));
            firstIndex = this.indexOfSlide(sortArray[0]);
        }

        // 删除操作
        const sdkSlides = slides.filter(cur => cur?.sdkData).map(curItem => curItem.sdkData);
        if (sdkSlides.length) {
            if (sdkSlides[0].type === DataType.SlideLayout) {
                (this.sdkData as PresentationModelSdkTypeV3)?.api?.removeLayouts(sdkSlides);
            } else {
                const sdk = this.sdkData as PresentationModelSdkTypeV3;
                if (sdk) {
                    transaction(() => {
                        sdkSlides.forEach((sdkSlide) => {
                            sdkSlide.api.removeAllComments();
                        });
                        if (sdk.sectionList?.length) {
                            sdk.api.removeSlidesWithSection(sdkSlides);
                        } else {
                            sdk.api.removeSlides(sdkSlides);
                        }
                    });
                }
            }
        }

        this.changeSelectionAfterDelete(
            isLayoutSlides ? MasterLayoutUtils.getUiLayoutList(this.masterList) : this.children,
            firstIndex,
        );
    }

    /**
     * 删除母版，仅支持3.0
     * 目前仅支持删除没有版式的空母版
     */
    public deleteMasters(pages: IMasterModel[]) {
        // 暂不支持混合删除
        if (pages.some(page => page.type !== UIModelType.MASTER)) return;

        window.log.info(`presentation deleteMaster start, count = ${pages.length}`);
        if (!this.sdkData) return;
        const sdkMasters = pages.filter(cur => cur?.sdkData).map(curItem => curItem.sdkData as IMasterDataModel);
        if (!sdkMasters?.length) return;

        // 暂不支持删除有版式的母版
        if (sdkMasters.some(master => master.layoutList.length > 0)) return;

        // 删除母版的同时删除对应主题
        const themeIds = sdkMasters.map(master => master.props.themeId);
        transaction(() => {
            (this.sdkData as PresentationModelSdkTypeV3)?.api?.removeMasters(sdkMasters);
            themeIds.forEach(themeId => (this.sdkData as PresentationModelSdkTypeV3)?.api?.removeThemeById(themeId));
        });
    }

    /**
     * 复制并添加新的slide页面
     * @param slides
     */
    public duplicateSlide(slides = this.selectionService?.selectedSlides.selectedArray || []): void {
        transaction(() => {
            if (!this.sdkData) return;
            const sdkSlides = slides.map(curItem => curItem.sdkData);
            this.handleDuplicateSlidesWithSections(slides);
            (this.sdkData as PresentationModelSdkTypeV3)?.api.duplicatePages(sdkSlides);
        });
    }

    /**
     * 替换新的slide页面到指定位置
     * @param slides
     * @param startCurrentId
     * @param startSlideModel
     */
    public replaceSlideToSelectedIndex(
        slides: ISlideModel[],
        startCurrentId: string,
        startSlideModel?: ISlideModel,
    ): void {
        const currentSlideModel = startSlideModel ?? this.selectionService?.currentSlide;
        const currentSlideIndex = this.indexOfSlide(currentSlideModel);
        transaction(() => {
            if (!this.sdkData) return;
            const sdkSlides = slides.map(curItem => curItem.sdkData?.getCloneData());
            const index = currentSlideIndex ?? 0;
            // 判断当前页是否被移动位置了
            if (startCurrentId === currentSlideModel?.id) {
                // 判断节
                if (this.sectionList?.length) {
                    const newIndex = ClearanceUtils.calcClearanceIndexFromSlideIndex(index, this.sectionList);
                    this.sdkData?.api.addSlidesWithSection(sdkSlides as ISlideData[], newIndex);
                } else {
                    this.sdkData?.api.addSlides(sdkSlides as ISlideData[], index);
                }
                this.deleteSlide([currentSlideModel]);
            } else {
                (this.sdkData as PresentationModelSdkTypeV3)?.api.addSlides(sdkSlides as ISlideData[], index + 1);
            }
        });
        // FIXME: 由于替换逻辑不会变更 currentSlideIndex 触发 UI 刷新，同时页面可能不在左侧可视范围内导致元素没有渲染。这里主动触发一下 UI 刷新，之后可能有更好的方法
        currentSlideModel?.startConvertChildrenTask();
    }

    /**
     * 携带新的主题母版，替换新的slide页面到指定位置
     * @param newPresentation
     * @param slideId
     * @param startCurrentId
     * @param startSlideModel
     */
    public replacePresentationToSelectedIndex(
        newPresentation: IPresentationBaseModel,
        slideId: string,
        startCurrentId: string,
        startSlideModel?: ISlideModel,
    ): void {
        const currentSlideModel = startSlideModel ?? this.selectionService?.currentSlide;
        const currentSlideIndex = this.indexOfSlide(currentSlideModel) ?? 0;
        transaction(() => {
            const data = newPresentation.sdkData?.getCloneData();
            assert(data?.slideList, 'can not find template slide list');
            const slide = data.slideList.find(slide => slide.id === slideId);
            assert(slide, 'can not find selected slide');
            data.slideList = [slide];
            // 删除没有用到的版式、母版、主题
            const layout = data.layoutMap[slide.layoutId];
            assert(layout, 'can not find selected layout');
            const master = data.masterList.find(master => master.id === layout.masterId);
            assert(master, 'can not find selected master');
            master.layoutIdList = [layout.id];
            const theme = data.themeList.find(theme => theme.id === master.themeId);
            assert(theme, 'can not find selected theme');
            data.layoutMap = { [layout.id]: layout };
            data.masterList = [master];
            data.themeList = [theme];
            data.noteSlideMap = {};

            if (startCurrentId === currentSlideModel?.id) {
                // 判断节
                if (this.sectionList?.length) {
                    const newIndex = ClearanceUtils.calcClearanceIndexFromSlideIndex(
                        currentSlideIndex,
                        this.sectionList,
                    );
                    this.sdkData?.api.addPresentation(data, newIndex, true);
                } else {
                    this.sdkData?.api.addPresentation(data, currentSlideIndex);
                }
                this.deleteSlide([currentSlideModel]);
            } else {
                this.sdkData?.api.addPresentation(data, currentSlideIndex + 1);
            }
        });
        // FIXME: 由于替换逻辑不会变更 currentSlideIndex 触发 UI 刷新，同时页面可能不在左侧可视范围内导致元素没有渲染。这里主动触发一下 UI 刷新，之后可能有更好的方法
        currentSlideModel?.startConvertChildrenTask();
    }

    public hasSections(): boolean {
        return !!this.sectionList && this.sectionList.length !== 0;
    }

    /**
     * slideIndex In Presentation.
     * @param index
     * @returns {SlideModel}
     */
    public slideOfIndex(index) {
        if (!this.selectionService) {
            return null;
        }
        if (index >= 0 && index < this.selectionService.slides.length) {
            return this.selectionService.slides[index];
        }
        return null;
    }

    public indexOfSlide(slide) {
        if (this.selectionService) {
            return this.selectionService.slides.indexOf(slide);
        }
        return -1;
    }

    /**
     * 通过slide id和元素id，查找元素
     * @param slideId
     * @param eleId
     */
    public findElementWithId(slideId: string, eleId: string): IElementBaseModel | null {
        if (this.children?.length) {
            const slideModel = this.children.find(slide => slide.id === slideId);
            if (slideModel?.children?.length) {
                let findElement: IElementBaseModel | null = null;
                slideModel.children.forEach((element) => {
                    if (element.type === UIModelType.GROUP) {
                        enumerateGroupItems(element as IGroupModel, (childModel) => {
                            if (childModel.id === eleId) {
                                findElement = childModel;
                            }
                        });
                    } else if (element.id === eleId) {
                        findElement = element;
                    }
                });
                return findElement;
            }
        }
        return null;
    }

    public needConvertAtPageIndex = (index, children = this.children): boolean => {
        if (children?.length > index) {
            return !children[index]?.childrenConverted;
        }
        return true;
    };

    public getSlideUniqueIDAtIndex = (index: number): string => {
        const slide = this.sdkData?.slideList?.[index];
        return slide?.id || '';
    };

    /**
     * 转换首页幻灯片的时候，同时转换关联的母版和版式
     * @param index
     * @param displayChildrenElement
     * @returns
     */
    public convertDataAtPageIndex = async (index, displayChildrenElement = true): Promise<void> => {
        if (!this.sdkData) return;

        const layoutModel = this.sdkData?.slideList?.[index]?.getLayout();
        const masterModel = layoutModel?.getMaster();
        const masterList = [masterModel];
        // 同步转换首页所需要的 master model 壳子，异步转 master model 的 children
        this.baseConvertDataAtPageIndex(index, displayChildrenElement, masterList, this.masterList, true);

        const layoutList = [layoutModel];
        // 同步转换首页所需要的 layout model 壳子，异步转 layout model 的 children
        this.baseConvertDataAtPageIndex(index, displayChildrenElement, layoutList, this.layoutList, true);

        this.baseConvertDataAtPageIndex(index, displayChildrenElement, this.sdkData?.slideList, this.children);

        // 同步转换首页所需要的 master layout 的非占位符 children
        const { masterKey, masterMapValue, layoutKey, layoutMapValue } =
            this.children[index]?.syncConvertRelationModelChildren() ?? {};
        masterMapValue && (this[masterKey] = masterMapValue);
        layoutMapValue && (this[layoutKey] = masterMapValue);

        if (masterModel) {
            // @ts-ignore
            const themeModel = masterModel?.getTheme();
            // 同步转换首页所需要的 master model 壳子，异步转 master model 的 children
            this.baseConvertDataAtPageIndex(index, displayChildrenElement, [themeModel], this.themeList, true);
        }
    };

    /**
     * 转换指定页面，默认是同步转换
     * @param index
     * @param displayChildrenElement
     * @param sdkDataList
     * @param uiDataList
     * @param asyncConvertChildren
     */
    public baseConvertDataAtPageIndex = async (
        index,
        displayChildrenElement = true,
        sdkDataList,
        uiDataList,
        asyncConvertChildren = false,
    ) => {
        const children = uiDataList;
        if (this.needConvertAtPageIndex(index, children)) {
            let uiModel;
            if (index >= children.length) {
                const type = ModelConverterBridge
                    .getUiTypeBySdkType(sdkDataList[index].type) as PresentationPropertyType;
                uiModel = createPageModel(type);
                uiModel.parent = this;
                uiModel.selectionService = this.selectionService;

                if (index === 0) {
                    uiModel.asyncConvertChildren = asyncConvertChildren;
                    uiModel.loadFirstPage = true;
                }
                uiModel.bindSDK(sdkDataList[index]);
            } else {
                uiModel = children[index];
            }

            uiModel.displayChildrenElement = displayChildrenElement;
            if (displayChildrenElement) {
                children.push(uiModel);
            } else if (!children[index]) {
                children[index] = uiModel;
            }
        }
    };

    public selectAll(): void {
        this.selectionService?.selectedSlides.clearAndAdd(...this.children);
    }

    // 幻灯片背景应用到全部
    public useSlideBgInMaster = (bgProps): void => {
        // 这里实现背景替换并不是通过 SDK 的数据来覆写的
        // 而是通过 UIModel 转成 SDK 数据进行提交
        // 必须把上层的 BlobUrl 换成 RelationshipID
        // 否则会将 BlobUrl 写入，导致图片刷新后无法加载
        const bgSrc = bgProps?.image?.src;
        if (bgSrc && ImageUrl.isBlobUrl(bgSrc)) {
            bgProps.image.src = ImageQuickLookManager.getInstance().getResourceByUrl(bgSrc)?.id ?? bgSrc;
        }

        const props = { style: { fillBackground: bgProps } };
        const updatePropsArray: Array<any> = [];
        const removePropsArray: Array<any> = [];
        const listElements: Array<any> = [];

        // 更改Master背景,有多个master的情况
        this.masterList.forEach((masterModel) => {
            const propsObj = UpdateAndRemoveLogic.convertToUpdateAndRemove(copy(props, true), masterModel.props);
            const updateProps = propsObj.update;
            const removeProps = propsObj.remove;
            updatePropsArray.push(updateProps);
            removePropsArray.push(removeProps);
            listElements.push(masterModel);
        });

        const emptyBg = {
            style: {
                fillBackground: null,
            },
        };
        // 清空所有slide背景
        this.layoutList.forEach((layoutModel) => {
            const currentLayoutModel = layoutModel;
            listElements.push(layoutModel);
            updatePropsArray.push(emptyBg);
            removePropsArray.push(emptyBg);

            if (_has(layoutModel, 'props.style.fillBackground')) {
                // 如果Layout本身bg为null，不会触发Layout刷新，但Layout又基础Master的bg，在这里改UI
                currentLayoutModel.props.style!.fillBackground = null;
            }
        });

        // 清空所有slide背景
        const curSlide = this.selectionService?.currentSlide;
        if (curSlide) {
            // 优先添加当前页，这样unDo时会最后通知到这一页
            listElements.push(curSlide);
            updatePropsArray.push(emptyBg);
            removePropsArray.push(emptyBg);
            this.children.forEach((slideModel) => {
                if (slideModel.id !== curSlide.id) {
                    listElements.push(slideModel);
                    updatePropsArray.push(emptyBg);
                    removePropsArray.push(emptyBg);
                }
            });
        } else {
            this.children.forEach((slideModel) => {
                listElements.push(slideModel);
                updatePropsArray.push(emptyBg);
                removePropsArray.push(emptyBg);
            });
        }
        if (bgProps.image) {
            this.updateBackgroundToImage(updatePropsArray, removePropsArray, listElements);
        } else {
            this.updateAndRemovePropsForElements(updatePropsArray, removePropsArray, listElements);
        }
    };

    public updateCustomSlideSize = (
        width: number,
        height: number,
        scale: number,
        type: STSlideSizeType,
    ) => {
        const presentationDataModel = this.sdkData as unknown as IPresentationDataModel;
        presentationDataModel?.api?.updateCustomSlideSizeWithScale(width, height, scale, type);
    };

    public updateCustomSlideSizeWithEnlargeOrReduce = (
        width: number,
        height: number,
        isEnlarge: boolean,
        type: STSlideSizeType,
    ) => {
        const presentationDataModel = this.sdkData as unknown as IPresentationDataModel;
        presentationDataModel?.api?.updateCustomSlideSizeWithEnlargeOrReduce(width, height, isEnlarge, type);
    };

    public updateCustomSlideSizeWithNoScale = (
        width: number,
        height: number,
        type: STSlideSizeType,
    ) => {
        (this.sdkData as unknown as IPresentationDataModel)?.api?.updateCustomSlideSizeWithNoScale(width, height, type);
    };

    // 幻灯片比例变化，以及批量更新-------

    public updateSlideSizeType = (type: SlideSizeType): void => {
        if (this.props?.slideSizeType === type) {
            return;
        }

        const typeInSdk =
            type === SlideSizeType.SLIDE_SIZE_4_3 ? STSlideSizeType.screen4x3 : STSlideSizeType.screen16x9;
        (this.sdkData as unknown as IPresentationDataModel)?.api?.updateSlideSizeType?.(typeInSdk);
    };

    public updateBackgroundToImage(
        propsArr,
        removeProps,
        elements: Array<any> = this.selectionService?.selectedElements.selectedArray || [],
    ): void {
        const prepareData = this.prepareUpdateAndRemoveData(propsArr, removeProps, elements);
        if (!prepareData) return;
        transaction(() => {
            prepareData.sdkDataArr.forEach((extendsSlide, index) => {
                BaseModel.sdkV3UpdateAndRemoveProps(
                    extendsSlide,
                    prepareData.sdkPropsArr[index],
                    prepareData.rmSdkPropsArr[index],
                );
            });
        });
    }

    public changeEditableState(state): void {
        this.operation.loading = !state;
    }

    public async convertMasterAndLayoutSdkDataToUiData(): Promise<void> {
        if (!this.sdkData) return;
        this.changeEditableState(false);
        const convertPromises: Array<Promise<void>> = [];
        if (this.sdkData.masterList?.length > 0) {
            const convertMasterPromise = ConvertEngine.convertArrayDataSdkToUi(
                () => MasterModel,
                this.sdkData.masterList,
                this.masterList,
                this,
                TaskPriority.NORMAL,
                this.getMasterAndLayoutConvertTaskGroup(),
            );
            convertPromises.push(convertMasterPromise);
        }

        if (this.sdkData.layoutList?.length >= 0) {
            const convertLayoutPromise = ConvertEngine.convertArrayDataSdkToUi(
                () => LayoutModel,
                this.sdkData.layoutList,
                this.layoutList,
                this,
                TaskPriority.NORMAL,
                this.getMasterAndLayoutConvertTaskGroup(),
            );
            convertPromises.push(convertLayoutPromise);
        }

        if (this.asyncConvertChildren) {
            await Promise.all(convertPromises);
        }

        this.resetMasterLayoutRelation();
        this.changeEditableState(true);
        if (this.asyncConvertChildren) {
            this.asyncConvertChildren = false;
        }
        eventBus.emit(EventKeys.MASTER_LAYOUT_CONVERTED);
        global.log.info('[key process]', 'MasterAndLayout convert end');
    }

    public getMasterAndLayoutConvertTaskGroup() {
        if (!this.masterAndLayoutTaskGroup
            || this.masterAndLayoutTaskGroup.isCanceled
            || this.masterAndLayoutTaskGroup.isFinished
        ) {
            this.masterAndLayoutTaskGroup = new TaskGroup(`convert-inherit-list-${this.type}(${this.key})`, TaskPriority.NORMAL);
            this.masterAndLayoutTaskGroup.concurrent = true;
        }
        return this.masterAndLayoutTaskGroup;
    }

    public async convertThemeSdkDataToUiData(): Promise<void> {
        if (!this.sdkData) {
            return;
        }
        let promise;
        if (this.sdkData.themeList?.length > 0) {
            promise = ConvertEngine.convertArrayDataSdkToUi(
                () => ThemeModel,
                this.sdkData.themeList,
                this.themeList,
                this,
            );
        }
        if (this.asyncConvertChildren) {
            await promise;
        }
    }

    /**
     * 如果继承自模板，表示模板children在presentation-base-model里Map的Key值
     * PC 是新逻辑，该方法不筛选 showMasterSp，直接返回匹配的 masterId
     * @returns {null|*}
     */
    public getMasterChildrenMapKey(sdkData): string | null {
        if (!sdkData) return null;
        if (sdkData.type === DataType.SlideMaster) {
            return sdkData.id;
        }
        if (sdkData.type === DataType.SlideLayout) {
            return sdkData.props.masterId;
        }
        return sdkData.getLayout?.()?.getMaster?.()?.id;
    }

    /**
     * 如果继承自模板，表示模板children在presentation-base-model里Map的Key值
     * 目前移动端还是旧逻辑，需要筛选 showMasterSp，返回空 masterId 不渲染 masterWrapper
     * @returns {null|*}
     */
    public getMasterChildrenMapKeyForMobile(slideSdkData): string | null {
        if (slideSdkData) {
            const slideSdk = slideSdkData;
            const layoutSdk = slideSdk.getLayout();
            const masterSdk = slideSdk.getMaster();
            if (slideSdk.showMasterSp !== 0 && layoutSdk) {
                if (layoutSdk.showMasterSp !== 0 && masterSdk) {
                    return layoutSdk.props.masterId;
                }
            }
        }
        return null;
    }

    /**
     * 如果继承自模板，表示模板children在presentation-base-model里Map的Key值
     * PC 是新逻辑，该方法不筛选 showMasterSp，直接返回匹配的 layoutId
     * @returns {null|*}
     */
    public getLayoutChildrenMapKey(sdkData): string | null {
        if (!sdkData || sdkData.type === DataType.SlideMaster) return null;
        if (sdkData.type === DataType.SlideLayout) {
            return sdkData.id;
        }
        return sdkData.props.layoutId;
    }

    /**
     * 如果继承自模板，表示模板children在presentation-base-model里Map的Key值
     * 目前移动端还是旧逻辑，需要筛选 showMasterSp，返回空 layoutId 不渲染 layoutWrapper
     * @returns {null|*}
     */
    public getLayoutChildrenMapKeyForMobile(slideSdkData): string | null {
        if (slideSdkData) {
            const slideSdk = slideSdkData;
            const layoutSdk = slideSdk.getLayout();
            if (slideSdk.showMasterSp !== 0 && layoutSdk) {
                return slideSdkData.props.layoutId;
            }
        }
        return null;
    }

    /**
     * 获取 model 对应 master 上的所有的非占位符元素
     * 这里需要筛选 showMasterSp，否则非缓存逻辑外的（比如列表页缩略图）会显示异常
     * @param model
     * @returns
     */
    public getMasterChildrenOmitPLByModel(model) {
        const key = this.getMasterChildrenMapKey(model.sdkData);
        let showMasterSp;
        if (model.isSlide) {
            // 这里相关的layoutModel可能没转完，直接用sdk上的数据
            const layoutShow = (model.sdkData.getLayout()?.props?.showMasterSp ?? 1) ? 1 : 0;
            showMasterSp = model.showMasterSp && layoutShow;
        } else {
            ({ showMasterSp } = model);
        }
        if (key && showMasterSp) return this.masterChildrenMap[key] || [];
        return [];
    }

    /**
     * 获取 model 对应 layout 上的所有的非占位符元素
     * @param model
     * @returns
     */
    public getLayoutChildrenOmitPLByModel(model) {
        const key = this.getLayoutChildrenMapKey(model.sdkData) || '';
        const showMasterSp = model.isSlide ? model.showMasterSp : true;
        if (key && showMasterSp) return this.layoutChildrenMap[key] || [];
        return [];
    }

    public updateSelectedWithIndex(index) {
        if (!this.selectionService) return;
        if (index < this.selectionService.slides.length) {
            this.selectionService.selectedSlides.add(this.selectionService.slides[index]);
            this.selectionService.currentSlideIndex = index;
        } else {
            // 如果当前选中为最后一页的时候要选中上面的那页
            this.selectionService.selectedSlides.add(this.selectionService.slides[index - 1]);
            this.selectionService.currentSlideIndex = index - 1;
        }
    }

    /**
     * 更新主题字体
     * @param fontFamily
     * @returns
     */
    public updateThemeFontFamily(fontFamily) {
        if (!fontFamily) return;
        (this.sdkData as PresentationModelSdkTypeV3)?.api?.updateThemeFontFamily(fontFamily);
    }

    public getSectionProperty(): ISectionProperty {
        if (!this.sectionPropertyInstance) {
            const instance = new SectionProperty(this);
            this.sectionPropertyInstance = instance;
        }
        return this.sectionPropertyInstance;
    }

    public setSectionManagerDelegate(sectionManager: ISectionManager) {
        if (this.sectionManager) return;
        this.sectionManager = sectionManager;
    }

    public getStartPageIndex = (): number => {
        const slides = this.children;
        const result = slides.findIndex(slide => slide.isShowInPlay);
        return result === -1 ? 0 : result;
    };

    // eslint-disable-next-line complexity
    public getSiblingPageIndex = (currentPageIndex: number, prev?: boolean): number => {
        const slides = this.children;
        if (currentPageIndex < 0 || currentPageIndex > slides.length) {
            return currentPageIndex;
        }
        const step = prev ? -1 : 1;
        let result = currentPageIndex + step;
        const isStartPageShowInPlay = currentPageIndex === slides.length ? true : slides[currentPageIndex].isShowInPlay;
        for (; result < slides.length && result >= 0; result += step) {
            // 当开始页为非隐藏，且当前页隐藏时，继续跳过隐藏
            // 反之，当开始页隐藏，或者当前页非隐藏时，则说明不需要跳过了，返回当前结果
            if (!isStartPageShowInPlay || slides[result].isShowInPlay) {
                break;
            }
        }
        if (result === -1 && prev) {
            // 向前找合法页时找不到了，有可能有两种情况
            if (currentPageIndex === slides.length) {
                // 1. 有可能所有幻灯片都被隐藏，在结束页向前翻时应该翻到最后一页
                return slides.length - 1;
            }
            // 2. 有可能本页未隐藏，但是本页之前的所有页都隐藏了，这个时候点击上一页应该没反应
            return currentPageIndex;
        }
        return result;
    };

    public toggleShowSlides(slides: ISlideModel[], show: boolean): void {
        transaction(() => {
            slides.forEach((slide) => {
                if (slide.isShowInPlay !== show) {
                    slide.toggleShowSlide(show);
                }
            });
        });
    }

    /**
     * 3.0 sdk变更事件
     * @param sdkData
     * @param change
     * @protected
     */
    protected async sdkOnDidChangeV3(
        sdkData: IObservableDataModel,
        change?: DataModelChange & { source: MutationSource },
    ): Promise<void> {
        let beforeCurrentSlide;
        if (change) {
            beforeCurrentSlide = this.selectionService?.currentSlide;
        }
        await super.sdkOnDidChangeV3(sdkData, change);
        this.handleCurDisplaySLide(beforeCurrentSlide);
    }

    // eslint-disable-next-line complexity
    private addSlideV3(slides?: Array<ILayoutModel>): void {
        let currentGapIndex; // 当前选中的间隙索引
        let newSlideIndex; // 插入页后新页的索引
        if (this.selectionService?.slideClearanceIndex !== -1) {
            // 选中的是间隙
            currentGapIndex = this.selectionService?.slideClearanceIndex;
            if (this.sectionList?.length) {
                // 存在节的情况下
                newSlideIndex = ClearanceUtils.calcSlideIndexFromClearanceIndex(currentGapIndex, this.sectionList);
            } else {
                // 不存在节的情况下
                newSlideIndex = currentGapIndex;
            }
        } else if (this.sectionManager && this.sectionManager.selectedSectionIndex !== -1 && this.sectionList) {
            // 选中的是节
            const { selectedSectionIndex } = this.sectionManager;
            const firstSlideIndex = ClearanceUtils.calcFirstSlideIndexFromSectionIndex(
                selectedSectionIndex,
                this.sectionList,
            );
            const currentSectionNum = this.sectionList[selectedSectionIndex].numSlides;
            newSlideIndex = currentSectionNum > 0 ? firstSlideIndex + currentSectionNum : firstSlideIndex;
            currentGapIndex =
                ClearanceUtils.calcClearanceIndexFromSectionIndex(selectedSectionIndex, this.sectionList) +
                currentSectionNum;
            this.sectionManager?.expandSelectedSection();
        } else {
            // 选中的是slide页
            const currentSlideIndex = this.selectionService?.currentSlideIndex ?? 0;
            if (this.sectionList?.length) {
                // 存在节的情况下
                currentGapIndex = ClearanceUtils.calcClearanceIndexFromSlideIndex(currentSlideIndex, this.sectionList);
            } else {
                // 不存在节的情况下
                currentGapIndex = currentSlideIndex + 1;
            }
            newSlideIndex = currentSlideIndex + 1;
        }

        let sdkSlides;
        if (slides) {
            sdkSlides = slides.map((curItem) => {
                if (curItem instanceof LayoutModel) {
                    const slide: SlideModel = new SlideModel();
                    slide.layoutId = curItem.id;
                    const holders = (curItem?.sdkData as ILayoutDataModel | null)?.getInheritedPlaceholders() || [];
                    const sdkData: ISlideData = {
                        cSld: {
                            spTree: {
                                // @ts-ignore
                                shapeList: holders,
                            },
                        },
                        id: generate(),
                        layoutId: curItem.id || '',
                        type: DataType.Slide,
                    };
                    return sdkData;
                }
                return curItem.sdkData;
            });
        } else {
            const slide = new SlideModel();
            const sdkData: ISlideData = {
                cSld: {},
                id: generate(),
                layoutId: '',
                type: DataType.Slide,
            };
            SlidePropertyConverter.convertPartialDataFromUiToSdk(slide, sdkData);
            sdkSlides = [sdkData];
        }
        const sdkDataV3 = this.sdkData as PresentationDataModel;
        if (sdkDataV3?.sectionList?.length) {
            sdkDataV3?.api.addSlidesWithSection(sdkSlides, currentGapIndex);
        } else {
            sdkDataV3?.api.addSlides(sdkSlides, currentGapIndex);
        }

        this.selectionService?.selectedSlides
            .clearAndAdd(...this.children.slice(newSlideIndex, newSlideIndex + sdkSlides.length));
        if (this.selectionService) {
            this.selectionService.slideClearanceIndex = -1;
        }
        if (!browser.isMobile && this.sectionManager) {
            this.sectionManager.selectedSectionIndex = -1;
        }
        if (this.selectionService) {
            this.selectionService.currentSlideIndex = newSlideIndex;
        }
    }

    /**
     * 删除 slide 的后续改变选中态
     * @param slideList 删除的 slide 列表
     * @param firstIndex 删除的第一个 slide 索引
     */
    private changeSelectionAfterDelete(slideList: Array<ISlideModel> | Array<ILayoutModel>, firstIndex: number) {
        if (!this.selectionService) return;
        if (slideList.length !== 0 && firstIndex !== -1) {
            this.selectionService.selectedSlides.clear();
            if (firstIndex < slideList.length) {
                this.selectionService.selectedSlides.add(slideList[firstIndex]);
                this.selectionService.currentSlideIndex = firstIndex;
            } else {
                // 如果当前选中为最后一页的时候要选中上面的那页
                this.selectionService.selectedSlides.add(slideList[firstIndex - 1]);
                this.selectionService.currentSlideIndex = firstIndex - 1;
            }
        } else {
            this.selectionService.selectedSlides.clear();
            this.selectionService.currentSlideIndex = -1;
        }
    }

    /**
     * 由母版生成版式
     * @param masterDataV2OrV3 母版数据
     * @returns layoutData
     */
    private createLayoutFromMaster(masterDataV2OrV3: MasterDataModel) {
        const masterData = masterDataV2OrV3 as MasterDataModel;
        return {
            type: DataType.SlideLayout,
            masterId: masterData.id,
            cSld: {
                name: i18n.t('自定义版式'),
                spTree: {
                    id: generate(),
                    type: masterData.store.data.cSld.spTree?.type,
                    shapeList: masterData.store.data.cSld?.spTree?.shapeList
                        .filter(e => e?.type !== DataType.GroupShape &&
                                e?.nvPr?.ph &&
                                e.nvPr.ph.type !== STPlaceholderType.body)
                        .map((e) => {
                            const newItem = _cloneDeep(e) as IShapeData;
                            // 版式的xfrm/prstGeom以及段落上的属性都是从母版继承，所以删掉
                            _unset(newItem, 'spPr.xfrm');
                            _unset(newItem, 'spPr.prstGeom');
                            const paragraphList = newItem.txBody?.p?.map(item => ({
                                egTextRun: item.egTextRun,
                            }));
                            _set(newItem, 'txBody.p', paragraphList);
                            return newItem;
                        }),
                },
            },
        };
    }

    private handleCurDisplaySLide(beforeCurrentSlide?): void {
        if (!beforeCurrentSlide) return;
        const isNotSameEditType =
            (beforeCurrentSlide.isSlide && this.getMasterLayoutEditService()?.isMasterEditType) ||
            (!beforeCurrentSlide.isSlide && !this.getMasterLayoutEditService()?.isMasterEditType);
        if (!isNotSameEditType) return;
        transaction(() => {
            if (!this.selectionService) return;
            let newIndex = -1;
            newIndex = this.children.indexOf(beforeCurrentSlide);
            if (newIndex === -1 && this.children.length > 0) {
                newIndex =
                    this.selectionService.currentSlideIndex < this.children.length
                        ? this.selectionService.currentSlideIndex
                        : this.children.length - 1;
            }
            this.selectionService.currentSlideIndex = newIndex;

            let selectedSlides = this.selectionService.selectedSlides.selectedArray;
            selectedSlides = selectedSlides.filter(slide => this.children.indexOf(slide) !== -1);
            this.selectionService.selectedSlides.add(...selectedSlides);
        });
    }

    private handleDuplicateSlidesWithSections(slides): void {
        if (this.hasSections() && this.sectionList && slides.length > 0) {
            const lastSlideIndex = this.indexOfSlide(slides[slides.length - 1]);
            const sectionIndexOfLastSlide = ClearanceUtils.calcSectionIndexFromSlideIndex(
                lastSlideIndex,
                this.sectionList ?? [],
            );
            if (sectionIndexOfLastSlide < (this.sectionList.length ?? 0)) {
                const { numSlides } = this.sectionList[sectionIndexOfLastSlide];
                this.sectionList[sectionIndexOfLastSlide].updateProps({ numSlides: numSlides + slides.length });
            }
        }
    }

    private _addDefaultSlideCaseNone(): boolean {
        let ifRet = false;
        // 选择0个元素 or 一个slide 都没有
        if (
            this.selectionService?.slideClearanceIndex === 0 ||
            (this.selectionService?.slideClearanceIndex === -1 &&
                this.selectionService &&
                this.selectionService.currentSlideIndex === -1) ||
            !this.selectionService?.currentSlide
        ) {
            if (
                this.masterList[0]?.layoutList &&
                this.masterList[0].layoutList.length > 0 &&
                this.masterList[0].layoutList[0]
            ) {
                const layout = this.masterList[0].layoutList[0];
                this.addSlide([layout]);
            }
            ifRet = true;
        }
        return ifRet;
    }

    private _masterIndexCaseBelowZero(masterIndex): number {
        if (masterIndex === -1) {
            masterIndex = 0;
        }
        return masterIndex;
    }

    private _layoutIndexCaseBelowZero(layoutIndex, layoutList): number {
        if (layoutIndex === -1) {
            layoutIndex = 0;
        } else if (layoutIndex === 0) {
            layoutIndex = layoutList.length > 1 ? 1 : 0;
        }
        return layoutIndex;
    }

    // 因为sdk中layoutList平铺的，而UI上layout是与master关联的，这里将layout挂载到master中
    private resetMasterLayoutRelation(): void {
        transaction(() => {
            // 清空旧 layout 数据
            this.masterList.forEach((master: IMasterModel) => {
                master.layoutList = [];
            });
            // 重置 layout 数据
            this.layoutList?.forEach((layout: ILayoutModel) => {
                const currentLayout = layout;
                this.masterList.forEach((master: IMasterModel) => {
                    if (layout.masterId === master.id) {
                        master.layoutList.push(layout);
                        currentLayout.parent = master;
                    }
                });
            });
        });
    }

    private findToAddInheritInfo(): { masterIndex: number; layoutIndex: number } | null {
        let masterIndex = this.findInheritIndexOfCurrent(UIModelType.MASTER, this.masterList);
        masterIndex = this._masterIndexCaseBelowZero(masterIndex);
        if (!this.masterList[masterIndex]) {
            return null;
        }
        let layoutIndex = -1;
        const { layoutList } = this.masterList[masterIndex];
        if (!layoutList) {
            return null;
        }
        layoutIndex = this.findInheritIndexOfCurrent(UIModelType.LAYOUT, layoutList);
        layoutIndex = this._layoutIndexCaseBelowZero(layoutIndex, layoutList);
        return {
            masterIndex,
            layoutIndex,
        };
    }

    private findInheritIndexOfCurrent(inheritType, inheritList): number {
        const curSlide = this.selectionService?.currentSlide;
        if (!curSlide?.sdkData) return -1;
        let currentId;
        if (inheritType === UIModelType.MASTER) {
            currentId = (curSlide.sdkData as ISlideDataModel).getLayout()?.getMaster()?.id;
        }
        if (inheritType === UIModelType.LAYOUT) {
            currentId = (curSlide.sdkData as ISlideDataModel).getLayout()?.id;
        }
        let inheritIndex = -1;
        for (let i = 0; i < inheritList.length; i++) {
            if (currentId === inheritList[i].id) {
                inheritIndex = i;
                break;
            }
        }
        return inheritIndex;
    }

    private prepareUpdateAndRemoveData(
        propsArr,
        removeProps,
        elements,
    ): {
        sdkDataArr: Array<any>;
        sdkPropsArr: Array<any>;
        rmSdkPropsArr: Array<any>;
    } | null {
        window.log.info(`${'presentation prepareUpdateAndRemoveData ' + '[propsArr.length] = '}${
            propsArr.length
        } [removeProps.length] = ${removeProps.length} [elements.length] = ${elements.length}`);

        if (
            !(Array.isArray(elements) || isObservableArray(elements)) ||
            !(Array.isArray(propsArr) || isObservableArray(propsArr)) ||
            !(Array.isArray(removeProps) || isObservableArray(removeProps)) ||
            elements.length !== propsArr.length ||
            elements.length !== removeProps.length
        ) {
            return null;
        }

        const sdkDataArr: Array<any> = [];
        const sdkPropsArr: Array<any> = [];
        const rmSdkPropsArr: Array<any> = [];

        elements.forEach((itemUiModel, index) => {
            const emptyUiModel = {
                props: {},
            };

            emptyUiModel.props = propsArr[index];
            const sdkProps = {};
            Object.getPrototypeOf(itemUiModel).constructor.convertDataUiToSdk(emptyUiModel, sdkProps, itemUiModel);
            sdkPropsArr.push(sdkProps);

            const rmUiModel = {
                props: {},
            };
            const rmProp = removeProps[index];
            if (rmProp) {
                rmUiModel.props = removeProps[index];
                const rmSdkProps = {};
                Object.getPrototypeOf(itemUiModel).constructor.convertDataUiToSdk(rmUiModel, rmSdkProps, itemUiModel);
                rmSdkPropsArr.push(rmSdkProps);
            } else {
                rmSdkPropsArr.push(undefined);
            }

            sdkDataArr.push(itemUiModel.sdkData);
        });
        return {
            sdkDataArr,
            sdkPropsArr,
            rmSdkPropsArr,
        };
    }

    // eslint-disable-next-line consistent-return
    private updateAndRemovePropsForElements(
        propsArr,
        removeProps,
        elements: Array<any> = this.selectionService?.selectedElements.selectedArray || [],
    ): void {
        const prepareData = this.prepareUpdateAndRemoveData(propsArr, removeProps, elements);
        if (!prepareData) return;
        transaction(() => {
            prepareData.sdkDataArr.forEach((extendsSlide, index) => {
                BaseModel.sdkV3UpdateAndRemoveProps(
                    extendsSlide,
                    prepareData.sdkPropsArr[index],
                    prepareData.rmSdkPropsArr[index],
                );
            });
        });
    }

    private getSdkMasterChildrenRectStyle(sdkModel, radioX, radioY): any {
        const model: any = {
            props: { style: {} },
        };
        sdkToUIAddPosition(sdkModel.props.frame, model.props.style);
        const style: Record<string, number> = {};
        if (model.props.style.left !== undefined) {
            style.left = model.props.style.left * radioX;
        }
        if (model.props.style.top !== undefined) {
            style.top = model.props.style.top * radioY;
        }
        if (model.props.style.width !== undefined) {
            style.width = model.props.style.width * radioX;
        }
        if (model.props.style.height !== undefined) {
            style.height = model.props.style.height * radioY;
        }
        return {
            style,
        };
    }

    private addSlideFromInheritInfo(masterIndex, layoutIndex): void {
        if (masterIndex < 0 || layoutIndex < 0) return;
        if (
            this.masterList[masterIndex].layoutList.length > 0 &&
            this.masterList[masterIndex].layoutList[layoutIndex]
        ) {
            const layout = this.masterList[masterIndex].layoutList[layoutIndex];
            this.addSlide([layout]);
        }
    }
}

export default PresentationBaseModel;
